import { Injectable } from '@angular/core';
import { BookingConfirmationTemplate } from './booking-confirmation-template';
import { BookingFinalConfirmationTemplate } from './booking-final-confirmation-template';
import { BookingPreConfirmationTemplate } from './booking-pre-confirmation-template';
import { BookingReportTemplate } from './booking-report-template';
import { ContactRequestPdfTemplate } from './contact-request-pdf-template';
import { HttpService } from './service/http.service';
import { Language } from './language';
import { PdfDocumentHeaderFooter } from './pdf-document-header-footer';
import { PdfTemplateViewOption } from './pdf-template-view-option.enum';
import { MenuItem, SelectItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class PdfDocumentTemplateService {

  languages: Language[] = [];
  selectedLanguage!: Language;

  navigationItems: MenuItem[] = [];
  activeItem: MenuItem;
  
  selectedHeaderFooter!: PdfDocumentHeaderFooter;
  bookingPdftemplates: BookingReportTemplate[] = [];
  selectedBookingPdfTemplate!: BookingReportTemplate;
  contactRequestPdfTemplates: ContactRequestPdfTemplate[] = [];
  finalConfirmationTemplates: BookingFinalConfirmationTemplate[] = [];
  confirmationTemplates: BookingConfirmationTemplate[] = [];
  selectedContactRequestPdfTemplate!: ContactRequestPdfTemplate;
  selectedPreConfirmationTemplate!: BookingPreConfirmationTemplate;
  selectedFinalConfirmationTemplate!: BookingFinalConfirmationTemplate;
  selectedConfirmationTemplate!: BookingConfirmationTemplate;

  activeItemId!: number;

  public availableFields: SelectItem[] = [
    { label: "booking id", value: "$booking.id$"},
    { label: "booking start date", value: "$booking.startDate$"},
    { label: "booking end date", value: "$booking.endDate$"},
    { label: "booking created timestamp", value: "$booking.created$"},
    { label: "school name", value: "$booking.school.name$"},
    { label: "school emergency number", value: "$booking.school.emergencyPhoneNumber$" },
    { label: "student first name", value: "$booking.student.firstName$"},
    { label: "booking products (advanced only)", value: "$booking.confirmation.productList: { product | <div>$product.productType.name$ $product.description$ $product.amountInBaseCurrency$ </div>}$"},
    { label: "Lenny Face", value: "( ͡° ͜ʖ ͡°)" }
  ];

  constructor(
    private httpService: HttpService
  ) {
    this.httpService.getLanguages().subscribe(languages => {
      this.languages = languages;
      this.selectedLanguage = this.languages[0];
      this.activeItemId = PdfTemplateViewOption.BOOKING_RELATED;
    });
    this.navigationItems = [
      {
        id: "1", label: "Booking reports", command: () => {
          this.activeItemId = PdfTemplateViewOption.BOOKING_RELATED;
        }
      },
      {
        id: "2", label: "Lead related", command: () => {
          this.activeItemId = PdfTemplateViewOption.CONTACT_REQUEST_RELATED;
        }
      },
      {
        id: "3", label: "Header&Footer", command: () => {
          this.activeItemId = PdfTemplateViewOption.HEADER_FOOTER;
        }
      },
      {
        id: "4", label: "Confirmation", command: () => {
          this.activeItemId = PdfTemplateViewOption.PRE_CONFIRMATION;
        }
      },
      {
        id: "6", label: "Confirmation officielle", command: () => {
          this.activeItemId = PdfTemplateViewOption.CONFIRMATIONS;
        }
      },
      {
        id: "5", label: "Final confirmation", command: () => {
          this.activeItemId = PdfTemplateViewOption.FINAL_CONFIRMATIONS;
        }
      }
    ];
    this.activeItem = this.navigationItems[0];
   }
}
